import { Itinerary2, TRIP_PHASE } from '~/models/Itinerary'
import { Page } from '~/models/PaginatedItems'
import { BasePaginatedMemoryCache } from '~/passporter-services/basePaginatedMemoryCache'
import { Entity } from '~/passporter-services/baseMemoryCache'

export class TripsCache extends BasePaginatedMemoryCache<Itinerary2> {
	private getTripsKey(phase: TRIP_PHASE, userId: string, order: string, pageSize: number) {
		return `trips-${userId}-${phase}-${order}-${pageSize}`
	}

	public setTripsPage(
		phase: TRIP_PHASE,
		userId: string,
		order: string,
		page: Page<Itinerary2>,
		pageNumber: number,
		pageSize: number
	) {
		const key = this.getTripsKey(phase, userId, order, pageSize)
		this.setPage(key, { ...page, page: pageNumber, pageSize } as Page<Entity<Itinerary2>>)
	}

	public getTripsPage(
		phase: TRIP_PHASE,
		userId: string,
		order: string,
		pageNumber: number,
		pageSize: number
	): Page<Itinerary2> | undefined {
		const key = this.getTripsKey(phase, userId, order, pageSize)
		return this.getPage(key, pageNumber, pageSize)
	}
}
